import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LoadingContextType {
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
    showSpinner: () => void;
    hideSpinner: () => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        // Return default values during SSR to prevent errors
        return {
            isLoading: false,
            setLoading: () => { },
            showSpinner: () => { },
            hideSpinner: () => { },
        };
    }
    return context;
};

interface LoadingProviderProps {
    children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const setLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

    const showSpinner = () => {
        setIsLoading(true);
    };

    const hideSpinner = () => {
        setIsLoading(false);
    };

    return (
        <LoadingContext.Provider value={{ isLoading, setLoading, showSpinner, hideSpinner }}>
            {children}
        </LoadingContext.Provider>
    );
};
